<template>
    <v-sheet style="background-color:#fafafa;height:100%">
         <!--v-toolbar app floating elevation="0" style="border-bottom:1px solid #ddd" pb-5-->
        <v-app-bar
            app
            fixed
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; padding:0px; "
            
            elevation="0"
        >
            <v-btn :to="{name:'product_list_video'}" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>
         
            <v-toolbar-title> {{page_title}} 
                <img src="@/assets/youtube_logo.svg" width="100px" />               
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!--v-toolbar-items>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="salvar_rascunho" text elevation="0" color="primary">
                        <v-icon>save</v-icon>&nbsp; Salvar Rascunho
                    </v-btn>&nbsp;
                    <v-btn v-if="product.status == 'underanalysis'" @click="aprovar()" dark small elevation="0" color="indigo">
                        <v-icon>check_circle</v-icon>&nbsp; APROVAR
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn @click="salvar_rascunho" elevation="0" color="primary" dark small>
                        <v-icon>save</v-icon>
                    </v-btn>&nbsp;
                    <v-btn v-if="product.status == 'underanalysis'" @click="aprovar()" dark small elevation="0" color="indigo">
                        <v-icon>check_circle</v-icon>&nbsp;
                    </v-btn>
                </template>
            </v-toolbar-items-->
            <!--</v-toolbar-->
        </v-app-bar>

        <!--HELPER-->
      
        <v-layout wrap >
            <v-flex xs12 py-5 px-5 style="background-color:#fafafa">
                <v-form>
                    <v-layout wrap >
                        <v-flex xs12 sm8 lg8 mb-0>
                            <v-card elevation="1" mb-2>
                                <v-card-title style="color:#222; ">Informações do Vídeo</v-card-title>
                                <v-divider></v-divider>
                                <div>
                                    <v-form>
                                        <v-container py-3 grid-list-xl>
                                            <v-layout wrap>
                                                <v-flex xs12 md12>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Título do Vídeo"
                                                        messages="Nome do produto que será disponibilizado nas plataformas digitais"
                                                        v-validate="'required'"
                                                        data-vv-name="product_name"
                                                        v-model="product.name"
                                                        color="blue"
                                                        @click:append-outer="help('product_name')"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <v-dialog
                                                        ref="dialog"
                                                        v-model="modal"
                                                        persistent
                                                        full-width
                                                        width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="formated_date"
                                                                label="Data de lançamento"
                                                                readonly
                                                                messages="É recomendável que a data de lançamento do produto seja de, no mínimo, 15 dias. Clique no ícone <b>(?)</b> para saber mais."
                                                                v-on="on"
                                                                :error-messages="errors.collect('release_date')"
                                                                data-vv-name="release_date"
                                                                v-validate="'required'"
                                                                @click:append-outer="help('product_release')"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="release_date"
                                                            locale="pt-br"
                                                            scrollable
                                                            @change="saveDate"
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="modal = false ; date=null"
                                                            >Cancelar</v-btn>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="modal=false"
                                                            >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-dialog>
                                                </v-flex>

                                                <v-flex xs12 md6>
                                                    <v-text-field
                                                        label="Artista Principal"
                                                        class="purple-input"
                                                        messages="Nome que será utilizado em todas as plataformas"
                                                        v-model="artist.name"
                                                        disabled
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </div>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 sm4 lg4 class="mt-0 pl-2 mx-auto text-center">
                            <v-card elevation="1" color style="height:100%; " class="pt-5">
                                <div class="mx-auto my-auto text-center" style="text-align:center">
                                    Você tem uma miniatura/capa de vídeo para enviar?
                                    <br />Se não tiver, faremos uma para você.
                                    <br />
                                    
<v-row class="dark--text">
      <v-col cols="6" offset="4"><v-switch
                                        v-model="meu_thumb"
                                        label="Tenho"
                                        color="orange"
                                        
                                        hide-details
                                    ></v-switch></v-col>
      
    </v-row>

                                    <small>(precisa ser um JPEG ou PNG com 1920x1080)</small>
                                </div>
                                <template v-if="meu_thumb || computed_cover">
                                <div
                                    v-if="!computed_cover"
                                    @click="open_image_dialog"
                                    class="mx-auto my-auto text-center"
                                    style="height: 140px; width: 250px;border:1px solid #999; background-color:#999"
                                >
                                    <v-icon
                                        dark
                                        class="my-auto mx-auto"
                                        style="margin-top: 25% !important;"
                                    >mdi-camera</v-icon>
                                </div>

                                <div
                                    v-if="computed_thumbnail"
                                    class="mx-auto my-auto"
                                    style="height: 140px; width: 250px;"
                                >
                                    <v-img
                                        v-if="computed_thumbnail"
                                        :src="computed_thumbnail"
                                        height="140px"
                                    ></v-img>
                                </div>

                                <div class="mx-auto my-auto text-center py-3" style="width:60%">
                                    <v-btn
                                        color="red"
                                        v-if="computed_thumbnail"
                                        dark
                                        @click="openwindow(computed_cover)"                                       
                                    >Ver Imagem Original</v-btn>
                                    <!--v-file-input
                                        v-if="!computed_cover"
                                        accept="image/png, image/jpeg"
                                        placeholder="Escolha um thumb"
                                        append-outer-icon="help_outline"
                                        messages="(opcional) Esse é o thumbnail que entrará no seu vídeo no canal do Nova Música Gospel. Ele precisa ter as dimensões de 1920x1080"
                                        @change="onFileChange"
                                        @click:append-outer="help('product_cover')"
                                        v-model="item_cover"
                                        ref="cover_ref"
                                        :loading="sending_cover_loading"
                                    ></v-file-input-->
                                </div>
                                </template>
                            </v-card>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex xs12 sm12 lg12 mt-2>
                            <v-card elevation="1" color style="height:100%; ">
                                <v-layout wrap px-2>
                                    <v-flex xs12 sm12 lg12>
                                        <v-card-title
                                            style="color:#222; "
                                        >Descrição do vídeo (opcionais)</v-card-title>
                                        <v-divider></v-divider>
                                    </v-flex>

                                    <v-flex xs12 sm12 lg12 mt-4>
                                        <v-text-field
                                            outlined
                                            label="O link para o perfil artístico no  Twitter"
                                            class="purple-input"
                                            v-model="product.extras.twitter"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 lg12>
                                        <v-text-field
                                            outlined
                                            label="O link para o perfil artístico no  Facebook"
                                            class="purple-input"
                                            v-model="product.extras.facebook"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 lg12>
                                        <v-text-field
                                            outlined
                                            label="O link para o perfil artístico no Instagram"
                                            class="purple-input"
                                            hint="O link para a sua conta no Instagram"
                                            v-model="product.extras.instagram"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Informações para contatos e convites para eventos, shows ou cultos"
                                            v-model="product.extras.contact"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Digite o que você gostaria na descrição no seu vídeo"
                                            v-model="product.extras.description"
                                            auto-grow
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>

        <modalmessage
            :dialog_opened="message.dialog_opened"
            :title="message.title"
            :message="message.message"
            btn_1_text="entendi"
            @btn_1_clicked="modalmessage_entendi"
            ref="modal"
        />
    </v-sheet>
</template>
<style>
/**
 *Remove os botoes que são tipicos do input quando o type é field 
 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import VeeValidate from "vee-validate";
//components
import ProductService from "../../../../app/rest/products";
import modalmessage from "../../../../components/shared/modalmessage";


Vue.use(VeeValidate);
let productService = null;

export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        modalmessage        
    },
    data: () => ({
        release_date: null,
        tem_upc: false,
        moved_track_order: false,
        editable_product: null,
        audio_files: [],
        input_selected: null,
        cover: null,
        cover_file: null,
        sending_cover_loading: false,
        item_cover: null,
        panel_expanded: [0, 1, 2],
        tracks: [],
        modal: false,
        image_size: {},
        tmp_release_data: null,
        meu_thumb:false,
        product: {
            type: "",
            record_label_name: "Nova Música Gospel",
            release_date: null,
            own_upc: 0,
            extras: {},
            artist:{}
        },
        platforms: [],
        message: {
            dialog_opened: false,
            title: "",
            message: "",
            btn_1_text: ""
        },
        product_type_choosed: {},

        //dicionário de validação
        dictionary: {
            custom: {
                product_name: {
                    required: "O título do produto é bem importante, hein!"
                },
                type: {
                    required: "O formato do produto é obrigatório"
                },
                track_name: {
                    required: "O nome da faixa é obrigatório"
                },
                obras: {
                    required:
                        "É necessário ao menos uma obra vinculada a esse fonograma"
                },
                release_date: {
                    required:
                        "Data de lançamento é obrigatório, mesmo que seja para uma data no passado."
                },
                copyright_year: {
                    required: "Ano de copyright é obrigatório."
                },
                copyright: {
                    required: "Copyright do Produto é obrigatório."
                },
                copyright_phonogram: {
                    required: "Copyright da Gravação é obrigatório."
                }
            }
        }
    }),

    mounted() {
        this.$validator.localize("ptbr", this.dictionary);
    },
    computed: {
        ...mapGetters(["configs"]),
        artist: function(){      
            
            return this.product.artist;
        },
        formated_date: function() {
            return this.formatDate(this.release_date);
        },
        page_title() {
            if (this.product.id) {
                return "EDITANDO > " + this.product.name;
            } else {
                return "NOVO PRODUTO";
            }
        },
        computed_thumbnail(){
            if (this.product.thumbnail) {
                return process.env.VUE_APP_BASE_URL + this.product.thumbnail;
            } else if (this.thumbnail != null) {
                return this.thumbnail;
            } else {
                return false;
            }
        },
        computed_cover() {
            if (this.product.cover) {
                return process.env.VUE_APP_BASE_URL + this.product.cover;
            } else if (this.cover != null) {
                return this.thumcoverbnail;
            } else {
                return false;
            }
        }
    },
    beforeCreate: function() {
        productService = ProductService.build();

        if (this.$route.params)
            this.editable_product =
                this.$route.params.id == undefined
                    ? false
                    : this.$route.params.id;

        if (!this.editable_product) {
            return;
        }

          this.$store.dispatch("loading", false);
        productService
            .get_one(this.editable_product)
            .then(e => {
                if (e.items) {
                    if (!e.items.products.extras || e.items.products.extras == '[]') {
                        e.items.products.extras = {};
                    } else {
                        e.items.products.extras = JSON.parse(
                            e.items.products.extras
                        );
                    }
                    if(e.items.products.thumbnail){
                        this.meu_thumb = true;
                    }
                    this.product = e.items.products;
                    this.cover = this.product.thumbnail;
                } else {
                    this.$store.dispatch("loading", false);
                    this.$refs.modal.show({
                        title: "Não encontrado",
                        message: "O produto buscado não foi encontrado",
                        btn_1_text: "Entendi",
                        btn_1_action: () => {
                            this.$router.push({ name: "products" });
                        }
                    });
                }
            })
            .finally(() => {
                this.$store.dispatch("loading", false);
            });
    },
    created() {},
    watch: {
        "product.release_date": {
            handler: function() {
                if (
                    this.product.release_date == null ||
                    this.product.status != "draft"
                ) {
                    return;
                }

                this.release_date = this.product.release_date;
                var release = new Date(this.product.release_date);
                var ideal = new Date();
                ideal.setDate(ideal.getDate() + 19);
            },
            deep: true
        },

        item_cover() {
            if (!this.item_cover) {
                this.cover = null;
            }
        }
    },
    methods: {
        openwindow(url){
            window.open(url);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        saveDate(date, o) {
            this.product.release_date = date;
            this.release_date = date;
            //this.$refs.dialog.save(this.formatDate(date));
        },
        help(tag) {
            this.$refs.product_help.show(tag);
        },
        open_image_dialog() {
            //
            //console.log(this.$refs.cover_ref);
            this.$refs.cover_ref.$el.children[1].blur();
            this.$refs.cover_ref.$el.children[1].click();
            this.$refs.cover_ref.$el.children[1].focus();
        },
        modalmessage_entendi() {
            this.message.dialog_opened = false;
        },

        __salvar_rascunho() {
            this.$validator.validateAll().then(is_valid => {
                if (!is_valid) {
                    return;
                }

                this._salvar_rascunho();
            });
        },

        salvar_rascunho() {
            if (this.cover) {
            }

            return new Promise((resolve, reject) => {
                this.$validator.validate("product_name").then(is_valid => {
                    if (!is_valid) {
                        this.$refs.modal.show(
                            "Salvando o rascunho",
                            'Para salvar o rascunho o campo de "Nome do Produto" precisa ser preenchido.',
                            "Entendi"
                        );
                        return;
                    }

                    var _product = this.product;
                    //caso não esteja já definido
                    if (!_product.main_artist) {
                        _product.main_artist = this.artist.id;
                    }

                    _product.tracks = this.tracks;
                    this.$store.dispatch("loading_full");
                    productService
                        .saveMetadata(_product)
                        .then(e => {
                            if (!e.items.product.extras) {
                                e.items.product.extras = {};
                            } else {
                                e.items.product.extras = JSON.parse(
                                    e.items.product.extras
                                );
                            }
                            this.product = e.items.product;
                            //this.cover = this.product.thumbnail;

                            this.product = e.items.product;
                            resolve();
                        })
                        .finally(e => {
                            this.$store.dispatch("loading_full", false);
                        });
                });
            });
        },
        /**
         * Quando houver alteração no campo de input da imagem
         */
        onFileChange(e, ee) {
            if (e == null) return;
            this.createImage(e);
        },
        createImage(file) {
            var reader = new FileReader();
            var vm = this;

            reader.onload = e => {
                var _image = new Image();
                _image.src = e.target.result;
                this.cover = _image.src; //e.target.result;
                _image.onload = e => {
                    this.image_size = {
                        width: _image.width,
                        height: _image.height
                    };
                    this.image_size_check();
                };
                this.cover_file = file;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function() {
            //this.cover = null;
            //this.product.cover = null;
            this.thumbnail = this.product.thumbnail = this.cover = this.item_cover = this.product.cover = null;
            //this.cover_file = "";
        },
        uploadCover() {
            if (!this.product.id) {
                this.$refs.modal.show(
                    "Ops",
                    "Clique primeiro em salvar rascunho antes de adicionar uma capa.",
                    "entendi"
                );
                this.removeImage();
                return;
            }

            if (this.cover_file == null) {
                return;
            }

            this.sending_cover_loading = true;
            let params = {
                product_id: this.product.id,
                cover: this.cover_file
            };

            this.$store.dispatch("loading_full");
            productService
                .sendCover(params)
                .then(e => {
                    //console.log("retorno do sendCover");
                    //console.log(e);
                    this.product.cover = e.items.cover;
                    this.product.thumbnail = e.items.thumbnail;
                })
                .catch(e => {
                    this.cover = null;
                    this.item_cover = null;
                })
                .finally(e => {
                    this.sending_cover_loading = false;
                    this.$store.dispatch("loading_full", false);
                });
        },
        distribuir() {
            this.$validator.validateAll().then(is_valid => {
                console.log("isValid", is_valid);
                if (!is_valid) {
                    this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Os campos em vermelho são obrigatórios para que você distribua o seu conteúdo corretamente.</p><p>Alguns campos podem aparecer em vermelho mesmo preenchidos, isso significa que há um campo similiar que não está preenchido.</p>",
                        "Entendi"
                    );
                    return;
                }

                console.log("meu thumn", this.meu_thumb )
                console.log("cover", !this.product.cover)
                if (!this.computed_cover && this.meu_thumb) {
                    this.$refs.modal.show(
                        "Para distribuir",
                        "<p>Ficou faltando só a capa!</p>",
                        "Entendi"
                    );

                    return;
                }

                //tudo certo, vamos para o pagamento
                this.salvar_rascunho().then(e => {
                    let _product = this.product;
                    _product.tracks = this.tracks;
                    this.$router.push({
                        name: "payment",
                        params: { product: _product }
                    });
                });
            });
        },
        /**
         * Validações da imagem
         * A imagem não é obrigatória para o cadastro dos metadados, mas quando enviada
         * é necessária estar de acordo com as especificações minimas.
         */
        image_size_check() {
            if (typeof this.image_size != "object") {
                return null;
            }

            /**
             * Validamos se a imagem é quadrada primeiro
             */
            if (
                this.image_size.width !== 1920 &&
                this.image_size.height != 1080
            ) {
                this.$refs.modal.show(
                    "A imagem precisa ser retangular!",
                    "O YouTube exige o uso de uma imagem retangular nas dimensões de 1920x1080.",
                    "Entendi"
                );
                this.cover = null;
                this.item_cover = null;

                return false;
            }

            this.uploadCover();
        },
        is_item_disabled(val) {
            return val ? true : false;
        }
    },
    beforeRouteLeave(to, from, next) {
        const answer = true; //window.confirm('Você tem alterações que não foram salvas. Tem certeza que quer sair?')
        if (answer) {
            next();
        } else {
            next(false);
        }
    }
};
</script>
